module.exports = __webpack_public_path__ + "img/lev_no.09478598.png";